import React, { useState } from 'react';
import { Header } from '../../../components/Layout/Header';
import { Content } from '../../../components/Layout/Content';
import { L } from '../../../lib/i18n';
import styled from '@emotion/styled';
import { usePromise } from '../../../lib/react';
import ContentCalendarApi from '@app/api/public/ProjectContentCalendarApi';
import { NavLink } from 'react-router-dom';
import { Pagination } from '../../../components/Layout/Pagination';
import { RawHtml } from '../../../components/Layout/RawHtml';
import { style } from '../../../components/Shared/Style';
import { Icon } from '../../../components/Icon/Icon';
import { ContentCalendarStore } from '../ContentCalendarStore';
import { Button } from '@ourliving/ourliving-ui';
import { Table } from '../../../components/Table/Table';
import { Card } from '../../../components/Layout/Card';
import { Loading } from '../../../components/Loading/Loading';
import { useObserver } from 'mobx-react';
import { SearchField } from '../../../components/SearchField/SearchField';

interface Props {
    location: { search: string };
}

const Menu = styled.div({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: style.margin.s
});

const SearchMenu = styled.div({
    display: 'flex',
    paddingBottom: style.margin.s,
    justifyContent: 'space-between'
});

const TextRight = styled.div({
    textAlign: 'right'
});

const StyledNavLink = styled(NavLink)({
    textDecoration: 'none',
    color: style.colors.primary,
    lineHeight: '32px'
});

const Container = styled.div({
    display: 'flex'
});

export const CalendarListPage = (props: Props) => {
    const removeCalendar = (id: string) => {
        ContentCalendarStore.remove(id);
    };

    const [page, setPage] = useState(0);
    const [ready, list] = usePromise(async () => {
        return await ContentCalendarApi.list(page);
    }, [page]);

    const onChange = e => {
        ContentCalendarStore.searchFilter = e.target.value;
    };

    const noDate = () => {
        ContentCalendarStore.loadDate = undefined;
    };

    return useObserver(() => {
        if (!ready) {
            return <Loading />;
        }

        const f = list.items.filter(title => title.title.toLowerCase().includes(ContentCalendarStore.searchFilter));

        const items = f.map(it => ({
            title: (
                <StyledNavLink to={`/calendar/${it.id}`}>
                    <div>{it.title}</div>
                </StyledNavLink>
            ),
            description: (
                <StyledNavLink to={`/calendar/${it.id}`}>
                    <RawHtml content={it.description} />
                </StyledNavLink>
            ),
            published: (
                <StyledNavLink to={`/calendar/${it.id}`}>
                    <div>{it.id}</div>
                </StyledNavLink>
            ),
            boardmembers: (
                <>
                    <input type="checkbox" />
                </>
            ),
            trashcan: (
                <TextRight>
                    <Icon.TrashCan onClick={() => removeCalendar(it.id)} />
                </TextRight>
            )
        }));

        return (
            <>
                <Header title={L('calendar')} />
                <Content>
                    <Menu>
                        <StyledNavLink to={`/calendar/new`}>
                            <Button onClick={noDate}>{L('calendar_new')}</Button>
                        </StyledNavLink>
                    </Menu>
                    <Card background={style.colors.white}>
                        <SearchMenu>
                            <SearchField placeholder={L('search_event')} onChange={onChange} />
                            {L('amount')} {L('posts')}: {list.totalItems}
                        </SearchMenu>
                        <Container>
                            {ready && (
                                <div style={{ width: '100%' }}>
                                    <Table
                                        columns={[
                                            { key: 'title', header: L('title'), arrows: true, width: '0.5fr' },
                                            { key: 'description', header: L('info'), arrows: true, width: '0.5fr' },
                                            { key: 'published', header: L('published'), arrows: true, width: '0.5fr' },
                                            {
                                                key: 'boardmembers',
                                                header: L('boardmember_area'),
                                                arrows: true,
                                                width: '0.5fr'
                                            },
                                            {
                                                key: 'trashcan',
                                                width: '0.5fr'
                                            }
                                        ]}
                                        data={items}
                                    />
                                    <Pagination page={list} onChangePage={setPage} />
                                </div>
                            )}
                        </Container>
                    </Card>
                </Content>
            </>
        );
    });
};
